import { Box, IconButton, Typography } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface PreferenceSectionHeaderProps {
  title: string
  onEdit: () => void
  canEdit: boolean
  editButtonTestId?: string
}

export const PreferenceSectionHeader: FC<PreferenceSectionHeaderProps> = ({
  title,
  onEdit,
  canEdit,
  editButtonTestId,
}) => {
  return (
    <Box className='flex items-center justify-between'>
      <Typography variant='subtitle1' className='text-base font-medium text-gray-900'>
        {title}
      </Typography>
      {canEdit && (
        <IconButton size='small' color='primary' onClick={onEdit} data-testid={editButtonTestId}>
          <EditOutlined className='size-5' />
        </IconButton>
      )}
    </Box>
  )
}
